import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { CoreContentModule } from "@obg/ngx.core.content";
import { RouterModule } from "@obg/ngx.router";
import { CompactFooterModule } from "@obg/ngx.ui.core";

import { SmForgotPasswordEmailUiModule } from "../forgot-password-email/sm-forgot-password-email/sm-forgot-password-email.module";
import { ForgotPasswordSelectionContainer } from "../forgot-password-selection/forgot-password-selection.container";

import { SmForgotPasswordContainer } from "./sm-forgot-password.container";

const DIRECTIVES = [SmForgotPasswordContainer, ForgotPasswordSelectionContainer];

@NgModule({
	imports: [
		CommonModule,
		CoreContentModule,
		CompactFooterModule,
		SmForgotPasswordEmailUiModule,
		RouterModule,
		MatButtonModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class SmForgotPasswordUiModule {}
